import { MOTTO_ALIGNERS_PATH } from '@/constants';
import { BffBrandType } from '@/gqlConstants';
import { OfficeInfoType } from '@/services/useFacilities';
import { BrandThemeConfig } from '@/types';

interface GetScheduleAppointmentUrlArgs {
	config: BrandThemeConfig;
	origin: string;
	selectedOffice: OfficeInfoType;
	getReasonForVisit: () => string;
}

export const getScheduleAppointmentUrl = ({
	config,
	origin,
	selectedOffice,
	getReasonForVisit,
}: GetScheduleAppointmentUrlArgs): string => {
	const basePath = config.features.otherApps.schedulingPath;

	if (!origin) return `/${basePath}?src=ops`;

	const officeCode = selectedOffice?.code ? `?fc=${selectedOffice.code}&src=ops` : '?src=ops';

	if (config.bffBrandType === BffBrandType.Motto) {
		return `${origin}/${basePath}/${MOTTO_ALIGNERS_PATH}/${officeCode}`;
	}

	const reasonForVisit = getReasonForVisit();
	const reasonPath = reasonForVisit ? `${reasonForVisit}/` : '';
	return `${origin}/${basePath}/${reasonPath}${officeCode}`;
};
